module.exports = __webpack_public_path__ + "static/media/app_jdtongxin_com.1acdf168.png";